import clsx from "clsx";
import React from "react";
import { Helmet } from "react-helmet";

const SectionBlock = ({
  title,
  items,
  className = "",
  showItemBullets = true,
}) => (
  <div
    className="flex flex-col items-center gap-2"
    style={{ marginBottom: "0px" }}
  >
    <h2 className={clsx("text-2xl text-gold", className)}>{title}</h2>
    {items.length > 0 && (
      <div className="tc flex justify-start container mx-auto">
        <ul
          className={clsx(showItemBullets ? "custom-list" : "-ml-4 list-none")}
        >
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

const WhyDrives = () => {
  return (
    <section className="section about-section">
      <Helmet>
        <title>Why Drives</title>
      </Helmet>

      <SectionBlock
        title="Why Drives, Why Now?"
        className="m-3"
        items={[
          "In-game wagering is a global phenomenon — but remains underdeveloped in U.S. sports markets.",
          "NFL and U.S. sports betting remains mostly pre-game and passive, with in-game options limited to arbitrary, binary bets with opaque pricing.",
          "Live, continuous markets deliver rapid action/response cycles that align with younger audiences' desire for fast, addictive decision-making environments..",
          "The convergence of proprietary and popular sports statistics into live betting markets unlocks powerful new fan and bettor experiences.",
        ]}
      />

      <SectionBlock
        title="Every Play is an Opportunity"
        items={[
          "Real-time engagement",
          "Simple, intuitive buy/sell decisions",
          "Quick turnover tied to live gameplay",
          "Synergies with traditional sportsbook betting",
        ]}
      />

      <SectionBlock
        title="The Player has Options"
        items={[
          "Buy/Sell then Hold",
          "Active Trade",
          "Target Crucial Plays",
          "Redzone Plays: Focus on Red Zone opportunities, where volatility and impact are highest.",
          "Hedge or leverage existing pre-game and prop exposures",
        ]}
      />

      <SectionBlock
        title="Operator Advantage"
        items={[
          "Extend session time and in-app handle with continuous micro-markets",
          "Generate context-aware props that match live fan interest",
          "Expanded in-game hedging options for real-time exposure management",
          "Raise limits while increasing handle, hold, and overall sportsbook ROI",
        ]}
      />

      <SectionBlock
        title="Drives Competitive Edge"
        items={[
          "Real-time market expertise",
          "Advanced AI and market reinforcement systems",
          "Proprietary pricing engines for rapid odds adjustments",
          "Proven Framework, Multi-Sport Future",
        ]}
      />
      <SectionBlock
        title="Proven Framework"
        showItemBullets={false}
        items={[
          "Launched in football and extending to baseball and golf - scalable anywhere real-time probabilities can be traded.",
        ]}
      />
    </section>
  );
};

export default WhyDrives;
